import { BaseModel } from './BaseModel';

export class FirewallRule extends BaseModel {
    public id = -1;
    public provider: string | null = null;
    public ruleId: string | null = null;
    public data: Record<string, unknown> | null = null;
    public source: 'egg' | 'manual' = 'egg';
}
